/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
import styled from '@essex/styled-components'
import { Label } from '@fluentui/react'

export const Flex = styled.div`
	display: flex;
	align-items: center;
`
export const FieldName = styled(Label as any)`
	margin: auto;
`
